import { render } from "./CashbackDescribePage.vue?vue&type=template&id=77f0e5cc&scoped=true"
const script = {}

import "./CashbackDescribePage.vue?vue&type=style&index=0&id=77f0e5cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77f0e5cc"]])

export default __exports__